import { render, staticRenderFns } from "./CertificacionesSection.vue?vue&type=template&id=ada0f23e&scoped=true"
import script from "./CertificacionesSection.vue?vue&type=script&lang=js"
export * from "./CertificacionesSection.vue?vue&type=script&lang=js"
import style0 from "./CertificacionesSection.vue?vue&type=style&index=0&id=ada0f23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0f23e",
  null
  
)

export default component.exports